import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function H() {
    const { useLang, useState, useRouter, Link } = useGlobal();
    const { t } = useLang('costsaving');
    const { locale } = useRouter();
    const cards: any = [
        {
            img: `/responsive/picture/cost-saving/8_1`,
            title: t('secH_card1_title'),
            desc: t('secH_card1_desc'),
            link: t('secH_card1_link'),
        },
        {
            img: `/responsive/picture/cost-saving/8_2`,
            title: t('secH_card2_title'),
            desc: t('secH_card2_desc'),
            link: t('secH_card2_link'),
        },
    ];

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    return (
        <div id="cost-saving-H" className={`cost-saving-H cost-saving-box ${css['cost-saving-H']}`}>
            <div className="text-info">
                <h2 className="title">{t('secH_title')}</h2>
                <p className="desc">{t('secH_desc')}</p>
            </div>
            <div className="cards-outer">
                <ul className="cards" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                    {cards?.map((card: any, k: number) => (
                        <li className="card" key={k}>
                            <p className="card-desc text">{card?.desc}</p>
                            <div className="card-img">
                                <EFPicture src={`${card?.img}.png`} srcPad={`${card?.img}_768.png`} srcMobile={`${card?.img}_768.png`} alt={card?.title} />
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
            <Link className="link" href="/app">
                <span className="link-text">{t('secH_link')}</span>
                <svg className="link-icon" xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                    <path d="M9 5.5L15.5 12L9 18.5" stroke="#3F68E0" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
            </Link>
        </div>
    );
}
